import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import {
  Stepper,
  Step,
  StepLabel,
  withStyles,
  StepButton,
  Hidden,
} from '@material-ui/core'
import { bindActionCreators } from 'redux'
import { stepperGoTo } from 'actions/view'

const StepperComponent = ({
  activeStep,
  steps,
  classes,
  templateID,
  stepperGoTo,
}) => {
  const stepper = (size) => {
    return (
      <Stepper
        classes={{ root: classes.root }}
        activeStep={activeStep}
        alternativeLabel
        nonLinear
        connector={size === 'small' ? null : undefined}
      >
        {steps.map((step, idx) => {
          const stepComponent = (
            <Step key={`${step.label}${idx}LabelKey`}>
              <StepButton
                icon={step.Icon}
                onClick={() => stepperGoTo(idx, 'template')}
              >
                <StepLabel
                  classes={{
                    alternativeLabel: classes.alternativeLabel,
                    active: classes.active,
                  }}
                >
                  {step.label}
                </StepLabel>
              </StepButton>
            </Step>
          )

          return stepComponent
        })}
      </Stepper>
    )
  }

  return (
    <Fragment>
      <Hidden smDown>{stepper('medium')}</Hidden>
      <Hidden mdUp>{stepper('small')}</Hidden>
    </Fragment>
  )
}

const styles = (theme) => ({
  root: {
    padding: 0,
    [theme.breakpoints.up('md')]: {
      width: 500,
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 10,
    },
    // marginTop: '-9px',
  },
  alternativeLabel: {
    marginTop: '0px !important',
    whiteSpace: 'nowrap',
    [theme.breakpoints.down('sm')]: {
      fontSize: 10,
    },
  },
  active: {
    color: '#18b940 !important',
  },
})

export default connect(
  (state) => ({
    activeStep: state.view.stepper.template,
  }),
  (dispatch) => bindActionCreators({ stepperGoTo }, dispatch),
)(withStyles(styles)(StepperComponent))
